import styled from "styled-components";

export const SubscribeAndSaveContainer = styled.div`
  background-color: ${props => props.theme.backgroundDark};
  border-radius: ${props => props.theme.borderRadiusContainers};
  padding: ${({ theme }) => theme.paddingContainersS};
  color: ${props => props.theme.textLight};

  .subscribe-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .info-icon {
      padding-right: 10px;
    }
  }

  .button-container {
    display: flex;
    flex-flow: row no-wrap;
  }

  .learn-more-button {
    padding: 0 20px;
  }

  .subscribe-button {
    padding: 0 20px;
    margin-right: 10px;
  }

  .description {
    padding: ${({ theme }) => theme.space[5]};
  }
`;

export const BlanketLicenseContainer = styled.div`
  background-color: ${({ theme }) => theme.subscribe};
  border-radius: ${({ theme }) => theme.borderRadiusContainers};
  padding: ${({ theme }) => theme.paddingContainersS};

  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[3]};
  }

  .blanket-license-button {
    background-color: ${({ theme }) => theme.textLight};
    color: ${({ theme }) => theme.subscribe};
    margin-left: auto;
  }
`;
